import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import debounce from 'lodash/debounce';


import * as actions from '../../actions';
import { getSelectedTabKey, getTabChildrenState } from '../../selectors';

import ChildrenPanelItem from './ChildrenPanelItem';
import TemplateLoader from '../common/TemplateLoader';


class ChildrenPanel extends Component {
  //eslint-disable-next-line
  static defaultProps = {
    dragEnabled: true,
    responsive: true,
    sortProp: 'position',
    filterProp: 'deleted',
    itemWidth: 130,
    itemHeight: 120 // Sync this with item height of item
  };


  constructor(props) {
    super(props);
    this.handleOnMove = debounce(this.handleOnMove.bind(this), 40);
  }


  handleOnMove(from, to) {
    const { moveChild } = this.props;
    moveChild(from, to);
  }


  render() {
    const { items, responsive, itemWidth, itemHeight, dragEnabled, sortProp, filterProp, isFetching, render } = this.props; 

    if (isFetching) {
      return <TemplateLoader />
    }

    const displayProps = {};

    const gridProps = {
      items,
      responsive,
      itemWidth,
      itemHeight,
      dragEnabled,
      sortProp,
      filterProp,
      onMove: this.handleOnMove
    };

    return (
      <div>
        {render(ChildrenPanelItem, displayProps, gridProps)}
      </div>
    );
  }
}


function mapStateToProps(state) {
  const key = getSelectedTabKey(state);
  const { isFetching, items } = getTabChildrenState(state, key);
  return {
    items,
    isFetching
  };
}


function mapDispatchToProps(dispatch) {
  const { moveChild } = actions
  return bindActionCreators({
    moveChild
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(ChildrenPanel);
